<template>
	<aside>
        <div>
            <compFormQuery v-if="type=='query'" :formdata="getBase" :value="formData" :labelWidth="150"></compFormQuery>
            <compFormEdit v-else class="margin-15 clearfix" ref="baseform" :formdata="getBase" v-model="formData" :labelWidth="150" />
        </div>
		<vButtonGroup class="text-right margin-top-15" v-if="type !== 'query'">
			<vButton theme="primary" @click="submit">保存</vButton>
			<vButton @click="close">取消</vButton>
		</vButtonGroup>
		<vLoading size="large" fix :loading="loading"></vLoading>
	</aside>
</template>
<script>
import { HttpSaveCostPackage, HttpCostPackageDetail } from '@/service/tasks';
import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
	mixins: [mixin],
    props: [ 'querytype', 'activeids', ],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import('@components/templates/formedit'),
	},
	data() {
		return {
            id: this.$route.query.id || this.activeids,
            type: this.$route.params.type || this.querytype,
			loading: false,
			formData: {},
		};
	},
	created() {
        this.update();
	},
	computed: {
        ...mapGetters('dictionary', ['getTransferWarehouse']),
		getBase() {
			return [
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    key: 'warehouse',
                    tag: 'vSelect',
                    options: this.warehouseList.map(item=>{
                        return {value: item.attach.id, label: item.label}
                    }) ,
                    props: {
                        filterable: true,
                    },
                    span: 24,
                },
                {
                    label: "包仓日期",
                    key: 'packageDate',
                    tag: 'vDatepicker',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd~yyyy-mm-dd',
                        confirm: false,
                    },
                    span: 24,
                },
                {
                    label: "包仓总体积（CBM）",
                    key: 'volume',
					tag: 'vInputNumber',
                    props: {
						min: 0,
					},
                    span: 24,
                },
			]
		},
	},
	methods: {
		update() {
            if(this.type == 'add') return
			this.loading = true
            HttpCostPackageDetail({
                id:this.id
            }).then(res=>{
                this.loading = false;
                this.formData = res.data;
                this.formData.warehouse = res.data.warehouseId;
                this.formData.packageDate = res.data.packStartAt + '~' + res.data.packEndAt;
            },err=>{
                this.loading = false;
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
		},
		close() {
			this.$emit('on-close')
		},
		async submit() {
            const valid = await this.$refs.baseform.validate();
			if (!valid) return;
            let warehouse = this.warehouseList.filter( item => item.attach.id === this.formData.warehouse)[0];
            let packStartAt = this.formData.packageDate.split('~')[0]
            let packEndAt = this.formData.packageDate.split('~')[1]
			this.loading = true
			HttpSaveCostPackage({id: this.id, orgId: global.SYSID, warehouseId: warehouse.attach.id, warehouseCode: warehouse.value, packStartAt, packEndAt, volume: this.formData.volume}).then(res => {
                this.$Message.success({
                    content: res.message,
                    duration: 30,
                    closable: true,
                });
				this.close();
				this.$emit('on-update');
			}, err => {
				this.loading = false;
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true,
                });
			})
		}
	}
};
</script>
